import ZSwitch from './ZSwitch.vue'

export default ZSwitch
